const mapStores = {};

module.exports = {
  dev: true,

  /**
   *  DOM HELPERS
   */
  $: document.querySelector.bind(document),
  $$: document.querySelectorAll.bind(document),
  $id: document.getElementById.bind(document),
  $class: document.getElementsByClassName.bind(document),
  $name: document.getElementsByName.bind(document),
  $tag: document.getElementsByTagName.bind(document),

  /**
   * CUBE CONSTANTS
   */
  constants: require('./lib-constants'),

  /**
   * CUBE - HELPER AJAX
   */
  ajax: require('./lib-ajax'),

  /**
   * CUBE - RELOAD CARTRIDGE
   */
  cartridge: require('./lib-cartridge'),

  /**
   * EVENT :
   *  Event handler (Pub/Sub system)
   */
  event: require('./lib-event'),

  /**
   * UTILITY FUNCTIONS - UI RELATED
   */
  ui: require('./lib-ui'),

  /**
   * UTILITY FUNCTIONS - ALERTING
   */
  alert: require('./lib-alert'),

  /**
   * IMAGE LAZYLOAD
   */
  lazyload: require('./lib-lazyload'),

  /**
   * CAPTCHA LAZYLOAD
   */
  lazyLoadCaptcha: require('./lib-lazy-captcha'),

  /**
   * DYNAMIC STICKER
   */
  sticker: require('./lib-sticker'),

  /**
   * LIGHT SLIDER
   */
  lightSlider: require('./lib-light-slider'),

  /**
   * PRODUCT ITEM
   */
  productSlider: require('./lib-product-item'),

  /**
   * MODAL V2
   */
  modalV2: require('./lib-modal-v2'),

  /**
   * FULL-WIDTH SLIDER
   */
  fullWidthSlider: require('./lib-full-width-slider'),

  /**
   * CUBE STORE
   *  - Share variables or methods accross application
   */
  store(name) {
    if (!mapStores[name]) mapStores[name] = {};
    return mapStores[name];
  },

  /**
   * PRICE FORMATTER
   * - Format a price from a js params variable named priceFormatterInfos
   */
  priceFormatter: require('./lib-price-formatter'),

  /**
   * PRICE BUILDER
   * - Create an HTML price tag
  */
  priceBuilder: require('@/commons/component/price/price-builder').init,

  /**
   * CUBE ASYNC JS
   *  - Get external JS files / dependencies
   *  - Get dynamic cube modules
   */
  asyncJS: require('./lib-async-js'),

  /**
   * CUBE DEBOUNCE
   * (inspired by underscore)
   */
  debounce: require('./lib-debounce'),

  /**
   * CIS FORM UTILS
   */
  form: {
    /*
    * ADDRESS
    * - Handle generic address form "ac_formgenerator.scala.html"
    */
    address: require('./form/lib-form-address'),
  },

  /**
   * UTILS
   *  - Various libs
   */
  utils: require('./lib-utils'),

  /**
   * STORES
   */
  stores: require('./lib-stores'),

  /**
   * Environment variables
   */
  env: require('./lib-env'),

  /* Local storage lib */
  storage: require('./lib-storage'),

  /* */
  updateModelNameDisplay: require('./lib-modelname'),

  /* Url Params */
  urlParams: window.location.search
    .slice(1)
    .split('&')
    .reduce((acc, e) => {
      const split = e.split('=');
      if (split[0]) acc[split[0]] = split[1];
      return acc;
    }, {}),

  /* TNR Util */
  tnr: require('./lib-tnr'),
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/libraries.js